/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { PAGE_TITLE } from '../../Configuration'
import { PascodeMetadata } from '../../assets/ts/data/pascode-metadata'
import {
  generateCodeOptionOnLength,
  generateSquadronOptions,
  getFilteredItems,
  getMAJCOMCode,
  getSquadrons,
  getUniqueCodes,
} from '../../assets/ts/general/general'
import Buttons from '../../components/buttons/buttons'
import usePageTitle from '../../hooks/use-page-title'
import usePascodeMetadata from '../../hooks/use-pascode-metadata'
import useQuickLinks from '../../hooks/use-quick-links'
import PageHeader from '../../layouts/header/page-header'
import { MetadataContext } from '../../store/metadata-context-provider'
import { PreviousPageContext } from '../../store/previous-page-provider'
import { RoleContext } from '../../store/role-context-provider'
import { UserContext } from '../../store/user-context-provider'
import {
  ALL_SELECT_LABEL,
  ALL_SELECT_OPTION,
  ALL_SELECT_OPTION_STRING,
  ALL_SELECT_VALUE,
  ALL_SELECT_VALUE_STRING,
} from '../../utils/constants/global-constants'
import NO_RESULTS from '../../utils/constants/no-results'
import CustomSelect from '../../utils/controls/custom-select'
import { Dropdown, optionsTypes } from '../../utils/controls/select-options-data'

interface IntialInputValues {
  componentValue: number
  majcomValue: number
  squadronValue: string
}

const QuickLinks = () => {
  usePageTitle(PAGE_TITLE.QUICK_LINKS)
  const { componentOptions, majcomOptions, majcoms, sectionOptions, sections } =
    useContext(MetadataContext)
  const sectionOption: optionsTypes[] = [
    ALL_SELECT_OPTION,
    ...sections.map(({ Label, Value }) => ({
      label: Label,
      value: Value,
    })),
  ]
  const { userProfile } = useContext(UserContext)

  const {
    initialInquiryAndDueoutFilter,
    isAssignedComponentOwner,
    isCPOwner,
    isCSS,
    isCustomer,
    isLeadership,
    isMAJCOMOwner,
    isMPFOwner,
    isSectionChief,
    isSectionOwner,
    isSiteAdmin,
    isSupervisor,
    isTechnician,
  } = useContext(RoleContext)
  const userLoginRole = {
    CSSPASCODEFilter: initialInquiryAndDueoutFilter?.cssPASCODES,
    usersAssignedComponentCode: initialInquiryAndDueoutFilter?.assignedComponentCodeFilter,
    usersMajcomCodeFilter: initialInquiryAndDueoutFilter?.majcomCodeFilter,
    usersSectionCodeFilter: initialInquiryAndDueoutFilter?.sectionCodeFilter,
    usersServicingOrganizationFilter: initialInquiryAndDueoutFilter?.servicingOrganizationFilter,
    usersServicingOrganizationWithoutSectionFilter:
      initialInquiryAndDueoutFilter?.servicingOrganizationWithoutSectionFilter,
  }
  const [intialComponentDropdown, setIntialComponentDropdown] = useState<optionsTypes[]>([
    ALL_SELECT_OPTION,
  ])
  const [intialMajcomDropdown, setIntialMajcomDropdown] = useState<optionsTypes[]>([
    ALL_SELECT_OPTION,
  ])
  const [majcomDropDown, setMajcomDropdown] = useState<optionsTypes[]>([])
  const [intialSquadronDropdown, setIntialSquadronDropdown] = useState<optionsTypes[]>([
    ALL_SELECT_OPTION,
  ])
  const [squadronDropDown, setSquadronDropDown] = useState<optionsTypes[]>([])

  const [intialInputValues, setIntialInputValues] = useState<IntialInputValues>({
    componentValue: ALL_SELECT_VALUE,
    majcomValue: ALL_SELECT_VALUE,
    squadronValue: ALL_SELECT_VALUE_STRING
  })
  const [dropdownValues, setDropdownValues] = useState<any>({
    assignedComponentCode: ALL_SELECT_VALUE,
    servicingMAJCOMCode: ALL_SELECT_VALUE,
    squadron: ALL_SELECT_VALUE_STRING,
  })
  const { quickLinks } = useQuickLinks({
    assignedComponentFilter: dropdownValues?.assignedComponentCode,
    isArchivedFilter: false,
    majcomOptions: intialMajcomDropdown,
    servicingMAJCOMFilter: dropdownValues?.servicingMAJCOMCode,
    squadronFilter: dropdownValues.squadron,
    squadronOptions: intialSquadronDropdown,
  })
  const { currentPage, setCurrentPage, setPreviousPage } = useContext(PreviousPageContext)

  const handleChange = (key: string, value: boolean | number | string) => {
    setDropdownValues((prev) => ({
      ...prev,
      [key]: value,
    }))
  }

  const changeAssignedComponent = (e: { label: string; value: number }) => {
    const option: Dropdown[] = majcoms
    .filter(({ ParentComponentCode }) => ParentComponentCode === e.value)
    .map(({ Label, Value }) => ({ label: Label, value: Value }))
  const intialmajcomCodes = intialMajcomDropdown.map(({ value }) => value)
  const options = option.filter(({ value }) => intialmajcomCodes.includes(value as number))
  if (options.length > 1) options.unshift(ALL_SELECT_OPTION)
  setMajcomDropdown(options as optionsTypes[])

  const servicingOrganizationOptions: any = [ 
    ALL_SELECT_OPTION_STRING,     
    ...Object.values(
      pascodeMetadata.filter((pascode) => (
        pascode.AssignedComponentCode === e.value
      )).map((pascode) => ({
        label: pascode.ServicingOrganization.replace('MPF','FSS'),
        value: pascode.ServicingOrganization.replace('MPF','FSS')
      })).reduce((acc, obj) => ({
      ...acc,
      [obj.value]: obj
    }), {}))]
  setSquadronDropDown(servicingOrganizationOptions)

    handleChange('assignedComponentCode', e.value)
    handleChange('servicingMAJCOMCode', options.length === 1 ? options[0].value as number: ALL_SELECT_VALUE)
    handleChange('squadron', servicingOrganizationOptions.length === 1 ? servicingOrganizationOptions[0].value as string: ALL_SELECT_VALUE_STRING )
  }
  const changeMajcom = (e: { label: string; value: number }) => {
    const servicingOrganizationOptions: any = [ 
      ALL_SELECT_OPTION_STRING,     
      ...Object.values(
        pascodeMetadata.filter((pascode) => (
          pascode?.ServicingMAJCOM === e.label || e.value === -1
        )).map((pascode) => ({
          label: pascode.ServicingOrganization.replace('MPF','FSS'),
          value: pascode.ServicingOrganization.replace('MPF','FSS')
        })).reduce((acc, obj) => ({
        ...acc,
        [obj.value]: obj
      }), {}))]
    setSquadronDropDown(servicingOrganizationOptions)
    handleChange('servicingMAJCOMCode', e.value)
    handleChange('squadron', servicingOrganizationOptions.length === 1 ? servicingOrganizationOptions[0].value as string: ALL_SELECT_VALUE_STRING )
  }
  const changeSquadron = (e: { label: string; value: number }) => {
    handleChange('squadron', e.value)
  }
  const formatQuickLinks = (data, sections) => {
    const result = sections
      .map((item) => {
        if (item?.label !== ALL_SELECT_LABEL) {
          const sectionLinks = separateBySectionCode(data, sections)[item?.value]
          if (!sectionLinks) {
            return null
          }

          return {
            content: sectionLinks.length ? (
              <ul className='list-type-none my-2 lh-1'>{createQuickLinkItems(sectionLinks)}</ul>
            ) : (
              <div>
              <NO_RESULTS/>
              </div>
            ),
            count: sectionLinks.length.toString().padStart(2, '0'),
            title: item.label,
          }
        }
        return null
      })
      .filter((item) => item !== null) // Remove null entries

    return result
  }
  function createQuickLinkItems(quicklinks) {
    return quicklinks?.map(({ Title, Url }) => (
      <li className='list-type-arrow my-2 p-relative' key={Title}>
        <Link
          className='title-color1 poppins-medium font-12 ps-3 p-relative d-inline-block py-1'
          rel='noopener noreferrer'
          target='_blank'
          title={Title}
          to={Url}
        >
          {Title}
        </Link>
      </li>
    ))
  }

  const separateBySectionCode = (quicklinks, sections) => {
    // Initialize the results object with all sections
    const results = {}
    sections.forEach((section) => {
      results[section.value] = []
    })

    // Populate the results object with items from quicklinks
    quicklinks.forEach((item) => {
      const sectionCodes = item.SectionCodes
      const sectionVal = item.Section
      if(item.SectionCodes.length === 0 ){
        sections.forEach((section ) => {
          results[section.value].push(item)
        })
      }
      sectionCodes.forEach((section, index) => {
      if (!results[section]) {
        results[section] = []
      }
      if (section) {
        results[section].push(item)
      }
      if(item[sectionVal[index]] === 'All') {
        sections.forEach((section) => {
          results[section.value].push(item)
        })
      }
    })
  })
    return results
  }

  const handleClearAll = () => {
    setDropdownValues({
      assignedComponentCode: intialInputValues.componentValue,
      servicingMAJCOMCode: intialInputValues.majcomValue,
      squadron: intialInputValues.squadronValue
    })
    setMajcomDropdown(intialMajcomDropdown)
    setSquadronDropDown(intialSquadronDropdown)
  }
  const { pascodeMetadata } = usePascodeMetadata({
    IsArchived: false,
  })

  const setintialOptions = (
    componentOptions: optionsTypes[],
    majcomOptions: optionsTypes[],
    squadronOptions: optionsTypes[],
    ownerIntialMajcom?: optionsTypes[],
    ownerIntialSqudronOptions?: optionsTypes[]
  ) => {
    const componentValue = userProfile[0].AssignedComponentCode
    const squadron = userProfile[0].ServicingOrganization.replace('MPF', 'FSS')
    const servicingMAJCOMCode = getMAJCOMCode(userProfile[0].ServicingMAJCOM, majcoms)
    setIntialComponentDropdown(componentOptions)
    setIntialMajcomDropdown(majcomOptions)
    setIntialSquadronDropdown(
      ownerIntialSqudronOptions ? ownerIntialSqudronOptions : squadronOptions
    )
    setSquadronDropDown(squadronOptions)
    setMajcomDropdown(ownerIntialMajcom ? ownerIntialMajcom : majcomOptions)
    const dropdownValues = {
      assignedComponentCode: componentValue,
      servicingMAJCOMCode: servicingMAJCOMCode,
      squadron: squadron
    }
    setIntialInputValues({
      componentValue: dropdownValues.assignedComponentCode as number,
      majcomValue: dropdownValues.servicingMAJCOMCode as number,
      squadronValue: dropdownValues.squadron as string
    })
    setDropdownValues((prev) => ({
      ...prev,
      ...dropdownValues,
    }))
  }

  useEffect(() => {
    const assignedComponentOptions = componentOptions.filter(
      ({ value }) => value !== ALL_SELECT_VALUE
    )
    if (isCPOwner || isSiteAdmin) {
      const profileComponentCode = userProfile[0].AssignedComponentCode
      const majcomCodes = majcoms
        .filter((item) => item.ParentComponentCode === profileComponentCode)
        .map((item) => item.MAJCOMCode)
      const majcomOption = generateCodeOptionOnLength(majcomOptions, majcomCodes)
      const squadrons = getSquadrons(
        pascodeMetadata,
        undefined,
        undefined,
        userProfile[0].ServicingMAJCOM
      )
      const ownerIntialSqudron = getSquadrons(pascodeMetadata)
      const ownerIntialSqudronOptions = generateSquadronOptions(ownerIntialSqudron)
      const squdronsOptions = generateSquadronOptions(squadrons)
      setintialOptions(
        assignedComponentOptions,
        majcomOptions,
        squdronsOptions,
        majcomOption,
        ownerIntialSqudronOptions
      )
    } else if (isAssignedComponentOwner) {
      const componentCodes = userLoginRole?.usersAssignedComponentCode
      const assignedComponentCodeOptions = generateCodeOptionOnLength(
        assignedComponentOptions,
        componentCodes
      )
      const majcomCodes = majcoms
        .filter((item) => componentCodes?.includes(item.ParentComponentCode))
        .map((item) => item.MAJCOMCode)
      const majcomOption = generateCodeOptionOnLength(majcomOptions, majcomCodes)
      const ownerSquadrons = getSquadrons(pascodeMetadata, undefined, componentCodes)
      const ownerSqudronsOptions = generateSquadronOptions(ownerSquadrons)
      const squadrons = getSquadrons(
        pascodeMetadata,
        undefined,
        componentCodes,
        userProfile[0].ServicingMAJCOM
      )
      const squdronsOptions = generateSquadronOptions(squadrons)
      setintialOptions(
        assignedComponentCodeOptions,
        majcomOption,
        squdronsOptions,
        undefined,
        ownerSqudronsOptions
      )
    } else if (isMAJCOMOwner) {
      const majcomCode = userLoginRole?.usersMajcomCodeFilter
      const profileMajcomCode = getMAJCOMCode(userProfile[0].ServicingMAJCOM, majcoms)
      const majcomCodes = majcomCode.includes(profileMajcomCode)
        ? majcomCode
        : (majcomCode.unshift(profileMajcomCode), majcomCode)
      const componentCodes = majcoms
        .filter((item) => majcomCodes?.includes(item.MAJCOMCode))
        .map((item) => item.ParentComponentCode)
      const assignedComponentCodeOptions = generateCodeOptionOnLength(
        assignedComponentOptions,
        componentCodes
      )
      const majcomOption = generateCodeOptionOnLength(majcomOptions, majcomCodes)
      const majcomNames = majcoms
        .filter((item) => majcomCodes?.includes(item.MAJCOMCode))
        .map((item) => item.Label)
      const squadrons = getSquadrons(
        pascodeMetadata,
        undefined,
        undefined,
        userProfile[0].ServicingMAJCOM
      )
      const squdronsOptions = generateSquadronOptions(squadrons)
      const ownerSquadrons = getSquadrons(
        pascodeMetadata,
        undefined,
        undefined,
        undefined,
        majcomNames
      )
      const ownerSqudronsOptions = generateSquadronOptions(ownerSquadrons)
      setintialOptions(
        assignedComponentCodeOptions,
        majcomOption,
        squdronsOptions,
        undefined,
        ownerSqudronsOptions
      )
    } else if (isLeadership || isMPFOwner) {
      const roleOrganizations =
      userLoginRole?.usersServicingOrganizationWithoutSectionFilter as string[]
    const profileOrganization = userProfile[0].ServicingOrganization
    const organizations = roleOrganizations.includes(profileOrganization)
      ? roleOrganizations
      : (roleOrganizations.unshift(profileOrganization), roleOrganizations)
      const filteredItems: PascodeMetadata[] = getFilteredItems(pascodeMetadata, organizations)
      const { componentCodes, servicingMAJCOMS } = getUniqueCodes(filteredItems)
      const majcomCodes = servicingMAJCOMS.map((item) => getMAJCOMCode(item, majcoms))
      const assignedComponentCodeOptions = generateCodeOptionOnLength(
        assignedComponentOptions,
        componentCodes
      )
      const majcomOption = generateCodeOptionOnLength(majcomOptions, majcomCodes)
      const squadrons = getSquadrons(
        pascodeMetadata,
        undefined,
        undefined,
        userProfile[0].ServicingMAJCOM,
        undefined,
        organizations
      )

      const squdronsOptions = generateSquadronOptions(squadrons)
      const ownerSqudronsOptions = generateSquadronOptions(organizations)
      setintialOptions(
        assignedComponentCodeOptions,
        majcomOption,
        squdronsOptions,
        undefined,
        ownerSqudronsOptions
      )
    } else if (isCSS) {
      const userCSSPASCODES = userLoginRole?.CSSPASCODEFilter
      const userProfilePASCODE = userProfile[0].PASCODE
      const cssPASCODES = userCSSPASCODES.includes(userProfilePASCODE)
        ? userCSSPASCODES
        : (userCSSPASCODES.unshift(userProfilePASCODE), userCSSPASCODES)
      const filteredItems = pascodeMetadata.filter((item) => cssPASCODES?.includes(item.PASCODE))
      const { componentCodes, organizations, servicingMAJCOMS } = getUniqueCodes(filteredItems)
      const majcomCodes = servicingMAJCOMS.map((item) => getMAJCOMCode(item, majcoms))
      const assignedComponentCodeOptions = generateCodeOptionOnLength(
        assignedComponentOptions,
        componentCodes
      )
      const majcomOption = generateCodeOptionOnLength(majcomOptions, majcomCodes)
      const squadrons = getSquadrons(
        pascodeMetadata,
        undefined,
        undefined,
        userProfile[0].ServicingMAJCOM,
        undefined,
        organizations
      )
      const squdronsOptions = generateSquadronOptions(squadrons)
      setintialOptions(
        assignedComponentCodeOptions,
        majcomOption,
        squdronsOptions,
        sectionOptions,
        undefined,
      )
    } else if (isSupervisor || isTechnician || isSectionChief || isSectionOwner) {
      const roleOrganizations = userLoginRole?.usersServicingOrganizationFilter as string[]
      const profileOrganization = userProfile[0].ServicingOrganization
      const organizations = roleOrganizations.includes(profileOrganization)
        ? roleOrganizations
        : (roleOrganizations.unshift(profileOrganization), roleOrganizations)
      const filteredItems = getFilteredItems(pascodeMetadata, organizations)
      const { componentCodes, servicingMAJCOMS } = getUniqueCodes(filteredItems)
      const majcomCodes = servicingMAJCOMS.map((item) => getMAJCOMCode(item, majcoms))
      const assignedComponentCodeOptions = generateCodeOptionOnLength(
        assignedComponentOptions,
        componentCodes
      )
      const majcomOption = generateCodeOptionOnLength(majcomOptions, majcomCodes)
      const squadrons = getSquadrons(
        pascodeMetadata,
        undefined,
        undefined,
        userProfile[0].ServicingMAJCOM,
        undefined,
        organizations
      )
      const squdronsOptions = generateSquadronOptions(squadrons)
      const ownerSqudronsOptions = generateSquadronOptions(organizations)
      setintialOptions(
        assignedComponentCodeOptions,
        majcomOption,
        squdronsOptions,
        undefined,
        ownerSqudronsOptions
      )
    } else {
      const componentCode = [userProfile[0].AssignedComponentCode]
      const servicingMAJCOMCode = [getMAJCOMCode(userProfile[0].ServicingMAJCOM, majcoms)]
      const assignedComponentCodeOptions = generateCodeOptionOnLength(
        assignedComponentOptions,
        componentCode
      )
      const majcomOption = generateCodeOptionOnLength(majcomOptions, servicingMAJCOMCode)
      const organizations = [userProfile[0].ServicingOrganization]
      const squdronsOptions = generateSquadronOptions(organizations)

      setintialOptions(assignedComponentCodeOptions, majcomOption, squdronsOptions, sectionOptions)
    }
  }, [
    isSiteAdmin,
    isCSS,
    isCPOwner,
    isAssignedComponentOwner,
    isMAJCOMOwner,
    pascodeMetadata,
    isCustomer,
  ])

  useEffect(() => {
    // This effect runs whenever the location changes (when the user navigates to a different route)
    if (currentPage !== location.pathname) {
      // User has navigated to a new page, so update the previous page
      setPreviousPage(currentPage) // Store the previous page
      setCurrentPage(location.pathname) // Update the current page
    }
  }, [location, currentPage]) // Runs whenever location or currentPage changes
  return (
    <>
      <PageHeader
        extras={
          <div className='d-flex flex-wrap align-items-center'>
            <div className='mx-2 mb-1'>
              <CustomSelect
                className='form-sm w-100 max-w-sm-200 min-w-sm-200  sourcesanspro font-13 customselect'
                formClassName='form-horizontal dash poppins-semibold font-12 title-color'
                id='AssignedComponent'
                inputProps={{
                  className: 'font-12 poppins-medium title-color',
                }}
                label='Assigned Component'
                name='Assigned Component'
                onChange={changeAssignedComponent}
                options={intialComponentDropdown}
                value={dropdownValues?.assignedComponentCode}
              />
            </div>
            <div className='mx-2 mb-1'>
              <CustomSelect
                className='form-sm w-100 max-w-sm-100 min-w-sm-100  sourcesanspro font-13 customselect'
                formClassName='form-horizontal dash poppins-semibold font-12 title-color'
                id='ServicingMAJCOM'
                inputProps={{
                  className: 'font-12 poppins-medium title-color',
                }}
                label='Servicing MAJCOM'
                name='Servicing MAJCOM'
                onChange={changeMajcom}
                options={majcomDropDown}
                value={dropdownValues?.servicingMAJCOMCode}
              />
            </div>
            <div className='mx-2 mb-1'>
              <CustomSelect
                className='form-sm w-100 max-w-sm-100 min-w-sm-100  sourcesanspro font-13 customselect'
                formClassName='form-horizontal dash poppins-semibold font-12 title-color'
                id='ServicingOrganization'
                inputProps={{
                  className: 'font-12 poppins-medium title-color',
                }}
                label='Servicing Organization'
                name='Servicing Organization'
                onChange={changeSquadron}
                options={squadronDropDown}
                value={dropdownValues?.squadron}
              />
            </div>
            <div className='ms-2 mb-1 ms-auto'>
              <Buttons
                className='btn btn-sm links ms-auto ms-sm-0 ms-md-0 p-0 links-underline'
                label='Clear All'
                onClick={handleClearAll}
                type='button'
              />
            </div>
          </div>
        }
        icon='icon-quicklinks2 font-14 me-1 color-primary'
        name='Quick Links'
      />
      <div className='container'>
        <div className='card shadow mt-3'>
          <div className='card-body quicklinksinfo'>
            <div className='row'>
              {formatQuickLinks(quickLinks, sectionOption).map((category: any) => (
                <div
                  className='col-sm-12 col-md-6 col-lg-3  mt-0 my-3 d-flex align-items-stretch '
                  key={category.title}
                >
                  <div className='dividerdashed vertical w-100'>
                    <div className='m-0'>
                      <h2
                        aria-describedby='heading'
                        className='font-12 poppins-bold title-color20 py-1 text-uppercase'
                        id='heading'
                        tabIndex={0}
                      >
                        {category.title} ({category.count})
                      </h2>
                    </div>
                    <div>{category.content}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default QuickLinks
